import React, { memo } from 'react';
import { createUseStyle } from '@redlink/assets/styles';
import { DataGridColumn } from './dataGridColumn';
import { DataGridTileColumn } from './dataGridTileColumn';
import { useDateFormat } from '@redlink/core';

export const DataGridDateTimeColumn = memo(
  ({ renderColumn, hovered, ...rest }) => {
    const { styles } = useStyle();
    const { getDateString, getTimeString } = useDateFormat();
    return (
      <DataGridColumn
        {...rest}
        renderColumn={(item, value) => {
          const valueItem = {
            date: value ? getDateString(value) : null,
            time: value ? getTimeString(value) : null,
          };
          return (
            <DataGridTileColumn
              {...rest}
              dataItem={valueItem}
              titleValueExtractor={(item) => item.time}
              subtitleValueExtractor={(item) => item.date}
              titleTextStyle={styles.titleText}
              subtitleTextStyle={[
                styles.subtitleText,
                // hovered && styles.subtitleTextHover,
              ]}
            />
          );
        }}
      />
    );
  }
);

const useStyle = createUseStyle(({ colors, size }) => ({
  titleText: {
    fontSize: 12,
    color: colors.gray22,
  },
  subtitleText: {
    fontSize: 14,
  },
  subtitleTextHover: {
    color: colors.blue1,
  },
}));
